var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleCalendarColored24 = function SvgGoogleCalendarColored24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-calendar-colored-24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.737 7.263-4.263-.474-5.21.474L6.788 12l.474 4.737 4.737.592 4.737-.592.474-4.855-.474-4.619Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M9.206 14.612c-.354-.239-.599-.588-.733-1.05l.822-.339c.075.284.205.505.391.661.185.156.41.233.673.233.268 0 .5-.081.692-.245a.783.783 0 0 0 .29-.624.774.774 0 0 0-.305-.632c-.204-.164-.46-.245-.765-.245h-.475v-.814h.426c.263 0 .485-.07.665-.213a.703.703 0 0 0 .27-.584c0-.22-.08-.395-.242-.527a.937.937 0 0 0-.612-.197c-.242 0-.433.064-.576.193a1.13 1.13 0 0 0-.31.474l-.813-.338c.107-.306.305-.576.595-.81.29-.232.661-.35 1.111-.35.333 0 .632.064.898.193.265.13.473.308.624.536.15.228.225.484.225.768 0 .29-.07.535-.21.737-.14.201-.311.355-.515.463v.048c.269.113.488.285.66.515.173.231.259.507.259.83 0 .322-.082.61-.245.861-.164.253-.39.452-.676.596a2.131 2.131 0 0 1-.97.218c-.416.001-.8-.118-1.154-.358Zm5.044-4.078-.898.652-.45-.684 1.618-1.168h.62v5.508h-.89v-4.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16.737 21 21 16.737l-2.131-.947-2.132.947-.947 2.132.947 2.131Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M6.316 18.869 7.263 21h9.474v-4.263H7.263l-.947 2.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M4.421 3A1.42 1.42 0 0 0 3 4.421v12.316l2.132.947 2.131-.947V7.263h9.474l.947-2.131L16.737 3H4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M3 16.737v2.842A1.42 1.42 0 0 0 4.421 21h2.842v-4.263H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M16.737 7.263v9.474H21V7.263l-2.131-.947-2.132.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M21 7.263V4.421A1.42 1.42 0 0 0 19.58 3h-2.842v4.263H21Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-calendar-colored-24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h18v18H3z"
  })))));
};
export default SvgGoogleCalendarColored24;